import { useLayoutEffect } from 'react';

export type LibertyPageKind = 'site-page' | 'panel-page' | 'auth-page';

/**
 * Liga o visual novo do Liberty na pagina montada.
 *
 * O CSS do Codex (liberty.css) foi feito pra classes no <body> (`site-page`,
 * `panel-page`, `auth-page`) e tokens no :root. Aqui a gente poe `lb-page` no
 * <html> + a classe da pagina no <body> enquanto a tela esta montada — e tira
 * ao desmontar, pra nada vazar pro painel GM (que tem layout proprio).
 */
export function useLibertyPage(kind: LibertyPageKind, title?: string) {
  useLayoutEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    html.classList.add('lb-page');
    body.classList.add(kind);
    const prevTitle = document.title;
    if (title) document.title = title;
    return () => {
      html.classList.remove('lb-page');
      body.classList.remove(kind);
      if (title) document.title = prevTitle;
    };
  }, [kind, title]);
}
